import script from "./ProjectEvaluationAreas.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEvaluationAreas.vue?vue&type=script&setup=true&lang=js"

import "./ProjectEvaluationAreas.vue?vue&type=style&index=0&id=3ff41382&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff41382"]])

export default __exports__